<template>
  <div class="menu-container arrow_box">
    <div class="body">
      <el-row :gutter="0">
        <el-col :span="12">
          <div
            class="main-item"
            :class="{
              selected: key === selected_main_key,
              hovered: key === hovered_main_key
            }"
            @mouseover="hovered_main_key = key"
            @mouseleave="hovered_main_key = null"
            v-for="(item, key) in menuItems['main-choices']"
            @click="selectItem(item, key, false)"
          >
            <span class="item-text">
              <i class="icon" :class="`iconp-${item.icon}`" />
              {{ item.title }}
            </span>
          </div>
        </el-col>
        <el-col :span="12">
          <div
            class="sub-item"
            :class="{
              selected: key === selected_sub_key,
              hovered: key === hovered_sub_key
            }"
            @mouseleave="hovered_sub_key = null"
            @mouseover="hovered_sub_key = key"
            v-for="(item, key) in sub_items"
            @click="selectItem(item, key, true)"
          >
            <span class="item-text">
              {{ item.title }}
            </span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SegmentCategorySelector',
  props: {
    menuItems: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    container: {},
    selected: {
      type: String
    }
  },
  data() {
    return {
      sub_items: [],
      selected_main_key: null,
      selected_sub_key: null,
      hovered_main_key: null,
      hovered_sub_key: null,
      hover_navigation_submenu: false
    }
  },
  mounted() {
    this.initSelection()
    this.hovered_sub_key = this.selected_sub_key
    this.hovered_main_key = this.selected_main_key
    $(this.container).on('keydown', e => {
      e.preventDefault()
      if (e.keyCode === 40) {
        if (!this.hover_navigation_submenu) {
          this.hovered_main_key = this.getNextMainItemKey()
        } else {
          this.hovered_sub_key = this.getNextMainItemKey()
        }
      } else if (e.keyCode === 38) {
        if (!this.hover_navigation_submenu) {
          this.hovered_main_key = this.getPrevMainItemKey()
        } else {
          this.hovered_sub_key = this.getPrevMainItemKey()
        }
      } else if (e.keyCode === 13 || e.keyCode === 39) {
        if (!this.hover_navigation_submenu) {
          this.selectItem(
            this.menuItems['main-choices'][this.hovered_main_key],
            this.hovered_main_key,
            false
          )
          this.hovered_sub_key = this.subMenuItemKeys[0]
        } else {
          if (this.hovered_main_key === null) {
            this.hovered_main_key = this.selected_main_key
          }
          let mainKeyFull = 'choice-' + this.hovered_main_key
          this.selectItem(
            this.menuItems[mainKeyFull][this.hovered_sub_key],
            this.hovered_sub_key,
            true
          )
        }
      } else if (e.keyCode === 37) {
        this.hover_navigation_submenu = false
        this.hovered_sub_key = null
      }
    })
  },
  destroyed() {
    $(this.container).off('keydown')
  },
  computed: {
    mainMenuItemKeys() {
      return Object.keys(this.menuItems['main-choices'])
    },
    subMenuItemKeys() {
      return Object.keys(this.sub_items)
    }
  },
  methods: {
    mouseleave() {
      this.hovered_main_key = null
      this.hovered_sub_key = null
    },
    getNextMainItemKey() {
      let itemKeys = this.hover_navigation_submenu
        ? this.subMenuItemKeys
        : this.mainMenuItemKeys

      let length = itemKeys.length
      let currentKeyIndex = itemKeys.indexOf(
        this.hover_navigation_submenu
          ? this.hovered_sub_key
          : this.hovered_main_key
      )
      if (currentKeyIndex < length - 1) {
        return itemKeys[currentKeyIndex + 1]
      } else {
        return itemKeys[currentKeyIndex]
      }
    },
    getPrevMainItemKey() {
      let itemKeys = this.hover_navigation_submenu
        ? this.subMenuItemKeys
        : this.mainMenuItemKeys

      let currentKeyIndex = itemKeys.indexOf(
        this.hover_navigation_submenu
          ? this.hovered_sub_key
          : this.hovered_main_key
      )
      if (currentKeyIndex > 0) {
        return itemKeys[currentKeyIndex - 1]
      } else {
        return itemKeys[0]
      }
    },
    initSelection() {
      for (let itemKey in this.menuItems) {
        for (let subItemKey in this.menuItems[itemKey]) {
          if (this.selected === subItemKey) {
            if (itemKey === 'main-choices') {
              this.selected_main_key = subItemKey
            } else {
              this.selected_main_key = itemKey.replace('choice-', '')
              this.sub_items = this.menuItems[itemKey]
              this.selected_sub_key = subItemKey
            }
          }
        }
      }
    },
    selectItem(item, key, isSubItem) {
      if (isSubItem) {
        this.selected_sub_key = key
      } else {
        this.selected_main_key = key
      }
      if (item.has_submenu) {
        this.sub_items = this.menuItems[`choice-${key}`]
        this.hover_navigation_submenu = true
      } else {
        $(this.container ? this.container : '.choices-container')
          .data('entity')
          .val(key)
          .trigger('change')
        $(this.container ? this.container : '.choices-container').fadeOut(200)
        if (!isSubItem) {
          this.sub_items = []
        }
        this.hover_navigation_submenu = false
        $(this.container)
          .closest('.condition-row-wrapper')
          .find('.jsEntityName')
          .focus()
      }
    }
  }
}
</script>

<style scoped>
.menu-container {
  background: #ffffff;
  border: 1px solid #dbdee7;
  box-sizing: border-box;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  min-width: 161px;
}
.main-item {
  width: 187px;
  height: 44px;
  padding: 10px;
  cursor: pointer;
  color: #4b515f;
  background-color: #f8fafc;
  border-bottom: 1px solid #f2f2f2;
}
.main-item.selected {
  background-color: #e6f3fb;
}
.main-item.hovered {
  background-color: #dee9ff;
}
.sub-item.selected {
  background-color: #e6f3fb;
}
.sub-item.hovered {
  background-color: #dee9ff;
}
.sub-item {
  width: 187px;
  height: 44px;
  padding: 10px;
  cursor: pointer;
  background-color: #ffffff;
  border-bottom: 1px solid #f2f2f2;
}
.item-text {
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.arrow_box {
  position: relative;
}
.arrow_box:after,
.arrow_box:before {
  bottom: 100%;
  left: 60px;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.arrow_box:after {
  border-bottom-color: white;
  border-width: 8px;
  margin-left: -8px;
}
.arrow_box:before {
  border-color: rgba(194, 225, 245, 0);
  border-bottom-color: #dbdee7;
  border-width: 10px;
  margin-left: -10px;
}
.icon {
  font-size: 22px;
  vertical-align: bottom;
  margin-right: 8px;
  line-height: 22px;
  color: #a7acba;
}
.body {
  max-width: 450px;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/SegmentCategorySelector.vue